import { createAction, props } from '@ngrx/store';

import { type UploaderView } from './uploader-view';

export const resetNavigationState = createAction('[Navigation] Reset state');

export const switchView = createAction('[Navigation] Switch view', props<{ view: UploaderView }>());
